<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { Primitive, type PrimitiveProps } from 'radix-vue';
import { type ButtonVariants, buttonVariants } from '.';
import LoadingSpinner from '../../icons/LoadingSpinner.vue';
import { computed } from 'vue';

interface Props extends PrimitiveProps {
  variant?: ButtonVariants['variant']
  size?: ButtonVariants['size']
  // Make sure to include !important (![class]) to classes to override both the default and dark mode,
  // or define classes for both default and dark mode (dark:[class])
  class?: HTMLAttributes['class']
  disabled?: boolean
  isLoading?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  as: 'button',
  variant: undefined,
  size: undefined,
  class: undefined,
});

const buttonClasses = computed(() => {
  const baseClasses = buttonVariants({ variant: props.variant, size: props.size });

  return baseClasses + ' ' + props.class;
});
</script>

<template>
  <Primitive
    :as="as"
    :as-child="asChild"
    :class="buttonClasses"
    :disabled="disabled"
  >
    <div class="flex justify-center items-center gap-2">
      <LoadingSpinner
        v-if="isLoading"
        class="w-5 h-5"
      />
      <template v-else>
        <slot name="iconLeft" />
        <slot />
        <slot name="iconRight" />
      </template>
    </div>
  </Primitive>
</template>
